import * as React from 'react';

function TickBlackFilled() {
  return (
    <svg
      width="14"
      height="11"
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7188 0.746454C12.9249 0.543178 13.2561 0.546002 13.4587 0.752762C13.6613 0.959522 13.6585 1.29192 13.4524 1.4952L4.87849 9.95353C4.67496 10.1543 4.34861 10.1544 4.14501 9.95367L0.475875 6.33668C0.269746 6.13348 0.266809 5.80108 0.469315 5.59424C0.671821 5.38741 1.00308 5.38446 1.20921 5.58766L4.51154 8.84306L12.7188 0.746454Z"
        fill="black"
      />
    </svg>
  );
}

export default TickBlackFilled;
